import styled, { css } from 'styled-components';
import { borderRadius, paddings } from '~/styled';
import type { ModalContentProps } from '../styled';

interface ModalTitleProps extends ModalContentProps {
  $centerTitle?: boolean;
}

type ModalButtonProps = Omit<ModalContentProps, '$stickyFooter'> & { $borderTop?: boolean };

export const ModalTitle = styled.div<ModalTitleProps>`
  padding: 0 ${paddings.defaultPadding};
  margin-top: ${paddings.defaultPadding};
  color: ${({ theme }) => theme.colors.onSurface};
  display: flex;
  flex-direction: row;
  ${(props) =>
    props.$centerTitle &&
    css`
      text-align: center;
      justify-content: center;
    `}
  h3 {
    font-weight: lighter;
  }

  h2 {
    margin-top: 0;
    margin-bottom: 0;
  }

  ${(props) =>
    props.$newStyle &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey300};
      padding: 0 ${paddings.defaultPadding} ${paddings.defaultPadding} ${paddings.defaultPadding};

      h3 {
        font-weight: 700;
      }
    `}

  ${(props) =>
    props.$stickyFooter &&
    css`
      box-sizing: border-box;
      overflow: auto;
    `}
`;

export const ModalButton = styled.div<ModalButtonProps>`
  min-height: 2em;

  padding: 0 ${paddings.defaultPadding} ${paddings.defaultPadding};
  text-align: right;
  button:not(:first-of-type) {
    margin-left: ${paddings.defaultPadding};
  }

  ${(props) =>
    props.$newStyle &&
    css`
      border-top: unset;
      padding-top: unset;
    `}
  button {
    text-transform: uppercase;
    font-weight: bold;
  }
  ${(props) =>
    props.$borderTop &&
    css`
      border-top: 1px solid ${({ theme }) => theme.colors.grey300};
    `}
`;

export const ModalContent = styled.div<ModalContentProps>`
  padding: ${paddings.defaultPadding};
  max-height: calc(100vh - 182px);
  overflow-y: auto;
  ${(props) =>
    props.$stickyFooter &&
    css`
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .CloseIcon {
        right: 1rem;
        top: 1rem;
      }
    `}
  ${(props) =>
    props.$newStyle &&
    css`
      border-radius: ${borderRadius.default};
    `}
`;
